'use strict';
import {
  GET_DATA_LIST,
  GET_MAIN_CATEGORY_LIST,
  UPDATE_LOADING_STATUS,
  UPDATE_PANNEL_MODAL,
  UPDATE_PANNEL_MODAL_LOADING_STATUS,
} from '../actions/managePannel';

const defVal = {
  dataList: [],
  total: 0,
  pageStart: 0,
  loading: true,
  modalItme: null,
  oprType: null,
  visible: false,
  loading: false,
  opType: 'ADD'
};

export default (state = defVal, action) => {
  switch (action.type) {
    case GET_DATA_LIST:
      return Object.assign({}, state, {
        dataList: action.dataList,
        pageStart: action.pageStart,
        total: action.total,
      });
      
    case UPDATE_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });
      
    case UPDATE_PANNEL_MODAL:
      return Object.assign({}, state, {
        modalItme:action.modalItme,
        visible: action.visible,
        opType: action.opType
      });

    case UPDATE_PANNEL_MODAL_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });
      
    default:
      return state;
  }
};
